import { render, staticRenderFns } from "./LinkToTemplate.vue?vue&type=template&id=45dbb8ac&"
import script from "./LinkToTemplate.vue?vue&type=script&lang=js&"
export * from "./LinkToTemplate.vue?vue&type=script&lang=js&"
import style0 from "./LinkToTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports